class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    // Find the inner <details> block. If missing, bail out safely.
    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle) {
      // Mark as inert so methods can early-return.
      this._inert = true;
      return;
    }

    const summary = this.mainDetailsToggle.querySelector('summary');
    if (!summary) { this._inert = true; return; }

    this.content = summary.nextElementSibling || null;

    // Attach listeners only if we have a real target
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    if (this._inert) return;
    setTimeout(() => {
      // Guard contains() in case the node was detached
      try {
        if (!this.contains(document.activeElement)) this.close();
      } catch (_) {}
    });
  }

  onToggle() {
    if (this._inert || !this.content) return;

    if (!this.animations) {
      try { this.animations = this.content.getAnimations ? this.content.getAnimations() : []; }
      catch { this.animations = []; }
    }

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation?.play?.());
    } else {
      this.animations.forEach((animation) => animation?.cancel?.());
    }
  }

  close() {
    if (this._inert || !this.mainDetailsToggle) return;
    this.mainDetailsToggle.removeAttribute('open');
    const sum = this.mainDetailsToggle.querySelector('summary');
    if (sum) sum.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    // If the base constructor marked us inert, don't try header work.
    if (this._inert) return;
    this.header = document.querySelector('.header-wrapper') || null;
  }

  onToggle() {
    if (this._inert || !this.header || !this.mainDetailsToggle) return;

    this.header.preventHide = this.mainDetailsToggle.open;

    const cssVar = document.documentElement.style.getPropertyValue('--header-bottom-position-desktop');
    if (cssVar !== '') return;

    const rect = this.header.getBoundingClientRect?.();
    if (!rect) return;

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(rect.bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
